@if (label) {
  <span class="multiple-select-dropdown-label mb-1 block text-xs">
    {{ label }}
    @if (requiredLabel) {
      <span class="font-bold text-aux-error">*</span>
    }
  </span>
}
<div class="multi-select flex">
  <ng-select
    class="w-full tabular-nums"
    [ngClass]="classes"
    [multiple]="multiple()"
    [clearable]="clearable"
    [searchable]="searchable"
    [placeholder]="placeholder"
    [formControl]="fc"
    [items]="items"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [loading]="loading"
    [appendTo]="appendTo"
    [closeOnSelect]="closeOnSelect"
    (ngModelChange)="onChange(fc.value)"
  >
    <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp class="flex-nowrap">
      @if (items.length <= maximumItemsToDisplay) {
        <div class="ng-value flex space-x-2 bg-transparent" style="background-color: transparent">
          @for (item of castToNgOption(items); track item) {
            <div class="flex" style="background-color: #ebf5ff">
              <span class="ng-value-icon left" aria-hidden="true" (mousedown)="clear(item)">×</span>

              <span
                class="ng-value-label overflow-hidden text-ellipsis"
                #text
                [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label || '' : ''"
                [auxTooltipPositions]="optionTooltipPositions"
              >
                {{ getOptionLabel(item) }}
              </span>
            </div>
          }
        </div>
      }

      @if (items.length > maximumItemsToDisplay) {
        <div class="ng-value">
          <span class="ng-value-label">{{ items.length }} Selected</span>
        </div>
      }
    </ng-template>
    @if (customOption) {
      <ng-template let-item="item" ng-option-tmp>
        <div
          auxTooltip
          [template]="
            optionTitle.offsetWidth < optionTitle.scrollWidth ||
            optionSubtitle.offsetWidth < optionSubtitle.scrollWidth
              ? tooltipTemplate
              : undefined
          "
          auxTooltipPanelContainerClass="multiple-select-dropdown-option-tooltip"
          class="pr-4 text-sm leading-5"
        >
          <p class="truncate font-bold" #optionTitle>
            {{ item.title }}
          </p>
          <p class="truncate italic" #optionSubtitle>
            {{ item.subTitle }}
          </p>
        </div>

        <ng-template #tooltipTemplate>
          <div>
            <p>{{ item.title }}</p>
            <p>{{ item.subTitle }}</p>
          </div>
        </ng-template>
      </ng-template>
    } @else {
      <ng-template let-item="item" ng-option-tmp>
        <div
          class="ng-value-label overflow-hidden text-ellipsis"
          #text
          [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
          [auxTooltipPositions]="optionTooltipPositions"
          auxTooltipPanelContainerClass="multiple-select-dropdown-option-tooltip"
          auxTooltipZIndex="1700"
        >
          {{ getOptionLabel(item) }}
        </div>
      </ng-template>
    }
  </ng-select>
  @if (prefix) {
    <div
      class="flex items-center justify-center rounded rounded-bl-none rounded-tl-none border border-aux-gray-dark"
      style="height: 35px; width: 25px; min-width: 25px"
      [ngClass]="{ 'cursor-pointer': !!prefixClick }"
      (click)="prefixClick && prefixClick()"
    >
      {{ prefix }}
    </div>
  }
</div>
